export const commons = {
  languages: {
    A1: 'A1 - Principiante',
    A2: 'A2 - Básico',
    B1: 'B1 - Intermedio',
    B2: 'B2 - Intermedio alto',
    C1: 'C1 - Avanzado',
    C2: 'C2 - Profesional',
    Native: 'Lengua materna'
  },
  roles: {
    club: 'Club',
    artist: 'Artista',
    admin: 'Administrador'
  },
  artistJobs: {
    Hostess: 'Anfitriona',
    GoGo: 'Go-go',
    Strip: 'Striptease'
  },
  schedule: {
    Monday: 'Lunes',
    Tuesday: 'Martes',
    Wednesday: 'Miércoles',
    Thursday: 'Jueves',
    Friday: 'Viernes',
    Saturday: 'Sábado',
    Sunday: 'Domingo'
  },
  paymentFrequency: {
    Daily: 'Diario',
    Weekly: 'Semanal',
    Monthly: 'Mensual'
  },
  flightPaymentType: {
    Club: 'A cargo del club',
    Artist: 'A cargo del artista',
    Credit: 'Préstamo',
    Agreement: 'Por acuerdo',
    Compensation: 'Compensación'
  },
  artistConsumation: {
    label: 'Consumo',
    Active: 'Activo',
    Passive: 'Pasivo'
  },
  workItemType: {
    Request: 'Solicitud',
    Invite: 'Invitación'
  },
  workItemStatus: {
    Pending: 'Pendiente',
    Accepted: 'Aceptado',
    Rejected: 'Rechazado',
    Withdrawn: 'Retirado',
    Expired: 'Expirado',
    ContractOngoing: 'Contrato en curso',
    ContractRequestedEndDate: 'Fin de contrato solicitado',
    FinishingContract: 'Finalizando contrato',
    ContractCompleted: 'Contrato completado',
    ClubSetEndDate: 'El club estableció la fecha de finalización',
    Cancelled: 'Cancelado'
  },
  artistStatuses: {
    LookingForWork: 'Buscando trabajo',
    OnContract: 'En contrato',
    FinishingContract: 'Terminando contrato',
    OnVacation: 'De vacaciones',
    HiddenFromSearch: 'Oculto en la búsqueda'
  },
  loading: {
    generic: 'Cargando datos...',
    requests: 'Cargando solicitudes...',
    invites: 'Cargando invitaciones...'
  },
  flightCompensationOptions: {
    oneMonth: 'Por 1 mes de contrato',
    twoMonths: 'Por 2 meses de contrato',
    threeMonths: 'Por 3 meses de contrato',
    sixMonths:
      'Durante 6 meses de contrato, el club compra un boleto de regreso',
    backTicket: 'Boleto de regreso'
  },
  transportFromAirport: {
    label: 'Transporte desde el aeropuerto/estación',
    options: {
      clubOrganizes: 'Organiza el club',
      artistSelf: 'La artista se encarga'
    }
  },
  notFound: {
    generic: 'El registro está vacío.',
    requests: 'Todavía no hay solicitudes.',
    invites: 'Todavía no hay invitaciones.',
    artists: 'Actualmente, la lista de artistas está vacía.',
    search:
      'No encontramos un club para tu búsqueda. Por favor, informa al soporte para que podamos mejorar la búsqueda.'
  },
  artistParametres: {
    weight: 'Peso',
    height: 'Altura',
    body: 'Cuerpo',
    chest: 'Busto',
    waist: 'Cintura',
    hips: 'Caderas'
  },
  dressCodeOptions: {
    strip: 'Striptease',
    underwear: 'Lencería',
    longDress: 'Vestido largo',
    body: 'Body',
    shortDress: 'Vestido corto'
  },
  time: {
    years: '{count, plural, one {# año} other {# años}}',
    months: '{count, plural, one {# mes} other {# meses}}',
    days: '{count, plural, one {# día} other {# días}}'
  },
  contact_support: '¿Necesitas ayuda? Contacta con soporte',
  success_send_data: 'Los datos se enviaron con éxito',
  show_full: 'Mostrar completo',
  worked_for: 'Trabajó en',
  club_reviews: 'Reseñas del club',
  club_response: 'Respuesta del club',
  response: 'Respuesta',
  send: 'Enviar',
  cm: 'cm',
  kg: 'kg',
  no_rating_yet: 'Todavía no hay calificación',
  rating_allow:
    'Los artistas pueden evaluar el club solo después de 21 días de trabajo',
  rating: 'Calificación',
  rating_popup_header_1: 'Tu contrato en el club',
  rating_popup_header_2: 'Finalizado',
  contractWeeks: '{count, plural, one {# semana} other {# semanas}}',
  rating_popup_text:
    'Es importante para nosotros y otros artistas conocer tu opinión sobre este lugar. Evalúa el trabajo en este club.',
  error_rating: 'Error en la calificación',
  no_rating:
    'No hay ningún elemento para evaluar este club o ya ha sido evaluado',
  housing_quality: 'Calidad de la vivienda',
  dressing_quality: 'Calidad del vestuario',
  management: 'Gestión y personal',
  anonymous: 'Deja la reseña de forma anónima',
  rate_work: 'Evaluación del trabajo en este club',
  submit: 'Enviar',
  years: 'años',
  allow_note: 'Permitir notificaciones',
  allow_note_1:
    'Permite las notificaciones para el correcto funcionamiento de la plataforma y no perder eventos importantes:',
  allow_note_2: 'Solicitudes e invitaciones',
  allow_note_3: 'Respuestas de clubes',
  allow_note_4: 'Mensajes de artistas o gerentes',
  allow_note_5: 'Enviamos solo notificaciones laborales, sin spam.',
  'follow-us-in-social': 'Síguenos en redes sociales:',
  continue: 'Continuar',
  'continue-with-google': 'Continuar con Google',
  artistHiringIsOpen: 'La contratación de artistas está abierta',
  artistHiringIsClosed: 'La contratación de artistas está cerrada',
  acceptWithExperience: 'Aceptamos con experiencia',
  dontAcceptWithoutExperience: 'No aceptamos sin experiencia',
  info: 'Información',
  copyLink: 'Copiar enlace',
  withExperience: 'Con experiencia',
  withouthExperience: 'Sin experiencia',
  agree: 'Estoy de acuerdo con las condiciones',
  change: 'Cambiar',
  add: 'Agregar',
  citizenship: 'Ciudadanía',
  selectCountry: 'Elige el país',
  save: 'Guardar',
  'save-and-continue': 'Guardar y continuar',
  edit: 'Editar',
  portfolio: 'Portafolio',
  close: 'Cerrar',
  closed: 'Cerrado',
  finish: 'Finalizar',
  help: 'Ayuda',
  logout: 'Salir',
  country: 'País',
  place: 'Ubicación',
  deleteAccount: 'Eliminar cuenta',
  changePassword: 'Cambiar contraseña',
  hide: 'Ocultar',
  delete: 'Eliminar',
  exit: 'Sí, quiero salir',
  'undo-to-account': 'Volver a la cuenta',
  location: 'Ubicación',
  language: 'Idioma',
  reviews: 'Reseñas',
  parametres: 'Parámetros',
  about: 'Sobre ti',
  my: 'Mi',
  photo: 'Foto',
  video: 'Video',
  experience: 'Experiencia',
  galery: 'Galería',
  write: 'Escribir',
  yes: 'Sí',
  step: 'Paso',
  no: 'No',
  or: 'O',
  resend: 'Reenviar',
  open: 'Abierto',
  cancel: 'Cancelar',
  need: 'Necesario',
  dontNeed: 'No necesario',
  endWork: 'Fin del trabajo',
  startDate: 'Fecha de inicio del trabajo',
  endDate: 'Fecha de finalización',
  vacancy: 'Vacante',
  creditation: 'Crédito de boletos',
  aroundTheClock: '24 horas',
  flightTickets: 'Boletos de vuelo',
  ticketCreditation: 'Crédito de boletos',
  crazyMenu: 'Menú loco',
  tea: 'Té',
  show: 'Espectáculo',
  deposit: 'Depósito',
  guarantee: 'Garantía',
  rate: 'Tarifa',
  clubFee: 'Tarifa del club',
  separated: 'Por separado',
  forShift: 'Por turno',
  required: 'Obligatorio',
  optional: 'Opcional',
  quantity: 'Cantidad',
  withouthExprience: 'Sin experiencia',
  choreographerInClub: 'Presencia de coreógrafo en el club',
  photoshootParticipation: 'Participación en sesiones de fotos',
  artistsInShift: 'Artistas por turno',
  scenes: 'Escenarios',
  dynamicPole: 'Barra dinámica',
  staticPole: 'Barra estática',
  artistTraining: 'Capacitación de artistas',
  teching: 'Formación',
  dressCodeForArtists: 'Código de vestimenta para artistas',
  dressCode: 'Código de vestimenta',
  rentPayment: 'Pago de alquiler',
  utilitiesPayment: 'Pago de servicios públicos',
  clubProvidedAccommodation:
    'Alojamiento del artista en los apartamentos del club',
  housingPhoto: 'Foto de la vivienda',
  noteEditLater: 'Puedes hacer cambios más tarde',
  paydByArtist: 'Pagado por el artista',
  paydByClub: 'Pagado por el club',
  peopleInRoom: 'Personas en la habitación',
  uploadFromDevice: 'Subir desde el dispositivo',
  uploadManyFromDevice: 'Subir varias fotos desde el dispositivo',
  selectMainPhoto: 'Elige la foto principal',
  photoParams: 'El tamaño de la foto no debe exceder __var_0__ MB',
  videoParams:
    'El tamaño del video no debe exceder __var_0__ MB. Formatos compatibles: MP4, QuickTime',
  general: 'General',
  payments: 'Pagos',
  full: 'Completo',
  topless: 'Topless',
  gogo: 'Go-go',
  crazymenu: 'Menú loco',
  continueFilling: 'Continuar completando',
  exitShort: 'Salir',
  search: 'Buscar',
  other: 'Otro',
  foreignLanguages: 'Idiomas extranjeros',
  dancer: 'Bailarina',
  untilNow: 'Hasta ahora',
  invite: 'Invitar',
  cancelInvite: 'Cancelar invitación',
  dateFormatPlaceholder: 'dd.mm.aa',
  askArtist: 'Hazle una pregunta al artista',
  askClub: 'Hazle una pregunta al club',
  reject: 'Rechazar',
  accept: 'Aceptar',
  confirm: 'Confirmar',
  iConfirm: 'Confirmo',
  workAt: 'Trabajar en',
  setLastDate: 'Establecer la última fecha',
  lastWorkDay: 'Último día de trabajo',
  cancelArrangement: 'Cancelar el acuerdo',
  back: 'Atrás',
  wantedVacancy: 'Vacantes deseadas',
  addClub: 'Agregar club',
  goToInvitation: 'Ir a la invitación',
  goToRequest: 'Ir a la solicitud',
  vacancyConsider: '¿Qué vacantes estás considerando?',
  super: 'Súper',
  clubLocation: 'Ubicación del club',
  specify: 'Especificar',
  housing: 'Alojamiento',
  position: 'Puesto',
  guest: 'Invitado',
  workingHours: 'Horario de apertura',
  isPaydByClub: 'Pagado por el club',
  isntPaydByClub: 'No pagado por el club',
  utilityPayments: 'Pago de servicios públicos',
  payment: 'Pago',
  request: 'Solicitud',
  penalties: 'Multas',
  aboutClub: 'Sobre el club',
  sendRequest: 'Enviar solicitud',
  cancelRequest: 'Cancelar solicitud',
  profile: 'Perfil',
  chat: 'Chat',
  housigInClubApartsRequired:
    'Se requiere alojamiento en los apartamentos del club'
};
